  <template>
  <v-app>
    <v-content id="mainContent">
      <v-alert :value="true" class="hide-on-print pl-8" type="success">Your application has been submitted
        successfully!
      </v-alert>
      <div class="mt-2 hide-on-print show-content"
           v-html="pdfDetails.show_content">


      </div>
      <div id="printContent" v-html="pdfDetails.print_content">

      </div>
      <v-dialog
          max-width="500"
          v-model="dialog"
      >
        <v-toolbar color="blue darken-3" dark>
          <v-toolbar-title>
            {{ $vuetify.lang.t('$vuetify.are_you_sure') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-card-text class="pt-3">
            <v-alert outlined type="info">
                            <span style="font-size: 23px;margin-top: 22px;">
                            {{ $vuetify.lang.t('$vuetify.read_the_instruction') }}
                            </span>
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                @click="dialog = false"
                color="red darken-1 white--text"
            >
              {{ $vuetify.lang.t('cancel') }}
            </v-btn>

            <v-btn
                @click="done"
                color="primary darken-1"
            >
              {{ $vuetify.lang.t('ok') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div class="mb-3 mr-4" style="display: flex; justify-content: flex-end;">

        <div>
          <!-- Clickable Terms and Condition -->


          <!-- Modal -->
<!--          <v-dialog v-model="showCardDialog" max-width="500">-->
<!--            <v-card>-->
<!--              <v-toolbar color="blue darken-3" dark>-->
<!--                <v-toolbar-title>Terms and Conditions</v-toolbar-title>-->
<!--                <v-spacer></v-spacer>-->
<!--                <v-btn icon @click="showCardDialog = false">-->
<!--                  <v-icon>mdi-close</v-icon>-->
<!--                </v-btn>-->
<!--              </v-toolbar>-->

<!--              <v-card-text>-->
<!--                <p class="mt-4  ">-->
<!--                  ▪ Service Payments made to the Government of Nepal’s Revenue Management Information System (RMIS) against Visa/Electronic Travel Authorization (ETA)/Permit are non-refundable under any circumstances.-->

<!--                </p>-->
<!--                <p>-->
<!--                  ▪ For any card payment-related queries or issues, please contact the Nepal Clearing House Ltd. (NCHL) Support Desk at support@nchl.com.np-->

<!--                </p>-->
<!--                <v-checkbox>sda</v-checkbox>-->
<!--              </v-card-text>-->

<!--              <v-card-actions>-->
<!--                <v-spacer></v-spacer>-->
<!--                <v-btn color="green" text @click="showCardDialog = false">Proceed</v-btn>-->
<!--              </v-card-actions>-->
<!--            </v-card>-->
<!--          </v-dialog>-->
          <v-dialog
              v-model="showCardDialog"
              max-width="520"
              transition="dialog-bottom-transition"
              persistent
          >
            <v-card
                class="rounded-xl overflow-hidden"
                elevation="10"
                style="

    "
            >
              <!-- Header -->
              <v-toolbar
                  flat
                  color="blue"
                  density="comfortable"
                  class="px-4 py-2"
              >
                <v-toolbar-title
                    class="text-h6 font-weight-bold text-uppercase tracking-wide blue"
                >
                  <v-icon left color="blue lighten-3">mdi-file-document-outline</v-icon>
                  Terms & Conditions
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    variant="text"
                    @click="showCardDialog = false"
                    class="text-white"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <!-- Body -->
              <v-card-text class="pt-0">
                <div
                    class="pa-4 rounded-lg"
                    style="
          font-size: 15px;
          line-height: 1.6;
        "
                >
                  <p class="mb-4 " style="color: black">
                    ▪ Service payments made to the Government of Nepal’s Revenue Management
                    Information System (RMIS) against Visa/Electronic Travel Authorization
                    (ETA)/Permit/On-Arrival are <strong>non-refundable</strong> under any circumstances.
                  </p>
                  <p style="color: black">
                    ▪ For any card payment-related queries or issues, please contact
                    <strong>Nepal Clearing House Ltd. (NCHL)</strong> Support Desk at
                    <a
                        href="mailto:support@nchl.com.np"
                        class="text-amber-300 font-weight-medium"
                    >
                      support@nchl.com.np
                    </a>.
                  </p>
                  <v-checkbox
                      v-model="acceptedTerms"
                      label="I have read and agree to the terms above"
                      color="amber"
                      hide-details
                      class="mt-4"
                  ></v-checkbox>
                </div>
              </v-card-text>

              <!-- Actions -->
              <v-card-actions class="justify-end pr-4 pb-3">
                <v-btn
                    variant="flat"
                    color="amber darken-2"
                    class="px-5 text-black font-weight-bold"
                    rounded
                    @click="showCardDialog = false, payThroughCard(pdfDetails)"
                    :disabled="!acceptedTerms"
                >
                  <v-icon left>mdi-check-circle</v-icon>
                  Proceed
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </div>


        <v-btn @click="print" class="hide-on-print hide-on-xs mr-3 " color="primary" depressed large>Print
        </v-btn>
        <v-btn
            @click="saveAsPdf"
            class="hide-on-print mr-3"
            color="secondary"
            depressed
            large>Download
        </v-btn>
        <v-btn
            @click="redirectHome"
            class="hide-on-print white--text  mr-3"
            color="green "
            depressed
            large
        >Done
        </v-btn>
        <v-btn
            v-if="$route.params.office == 'IO01'"
            @click="closeWindow"
            class="hide-on-print white--text  mr-3"
            color="error"
            depressed
            large
        >Close
        </v-btn>
        <v-btn v-if="pdfDetails.voucher_number && pdfDetails.submission_id.startsWith('V') && pdfDetails.online_payment" @click="showCardDialog=true" class="hide-on-print white--text hide-on-xs mr-3 " color="green" depressed large>Card Payment
        </v-btn>
        <v-btn v-if="pdfDetails.voucher_number && pdfDetails.submission_id.startsWith('V')" @click="payThroughFCGO(pdfDetails)" class="hide-on-print hide-on-xs mr-3 " color="warning" depressed large>Pay Online
        </v-btn>
      </div>
      <div class="mb-3 mr-4" style="display: flex; justify-content: flex-end;">
<!--        payThroughCard(pdfDetails)-->

      <v-btn  v-if="pdfDetails.voucher_number && pdfDetails.submission_id.startsWith('V') && pdfDetails.online_payment" @click="showCardDialog=true" class="hide-on-print hide-on-lg white--text  mr-3 " color="green" depressed large>Card Payment
      </v-btn>
      <v-btn v-if="pdfDetails.voucher_number && pdfDetails.submission_id.startsWith('V')" @click="payThroughFCGO(pdfDetails)" class="hide-on-print hide-on-lg mr-3 " color="warning" depressed large>Pay Online
      </v-btn>
<!--        <v-card v-if="showCardDialog">-->
<!--          asdasdaaaaaaaaa-->

<!--        </v-card>-->
      </div>
<!--      <div style="margin-left: 300px; display: flex">-->
<!--        <div style="color: red" class="mr-[100px] pl-[100px]">Note: Additional charges may apply for payments made by card.</div>-->
<!--        <div><p style="color: blue; cursor: pointer;-->
<!--             text-decoration: underline; margin-left: 10px" class="pr-10 cursor-pointer text-blue-600 " @click="showTerms = true">-->
<!--          <u>Terms and Condition</u>-->
<!--        </p></div>-->
<!--      </div>-->


    </v-content>
  </v-app>
</template>

<script>
import {API_URL, BASE_TOKEN, BASE_URL, VERSION} from "../config/config";
import Http from "axios";

export default {
  name: "VisaApplicationPrint",
  data() {
    return {
      logo: BASE_URL + "logo.png",
      dialog: false,
      showTerms: false,
      showCardDialog:false,
      acceptedTerms:false
    };
  },
  computed: {
    pdfDetails() {
      return this.$store.state.VisaSingle.pdfDetails;
    },
  },

  beforeRouteEnter(to, from, next) {
    if (!from.name || from.name === 'PrintApplication') {
      next(vm => {
        let apply_type = vm.$route.params.apply;
        let office = vm.$route.params.office;
        if (apply_type === 'arrival') {
          if (office === 'doi') {
            vm.$router.push({
              name: 'EntryVisaProcessing'
            })
            return
          }
          vm.$router.push({
            name: 'OnArrival',
            params: {office}
          })
        } else {
          vm.$router.push({
            name: 'OnlineApplication'
          })
        }
      })
    }
    next();
  },
  methods: {
    print() {
      window.print();
    },
    saveAsPdf() {
      window.open(this.pdfDetails.download_link, "_blank");
    },
    closeWindow() {
      window.close();
    },
    done() {

      let apply_type = this.$route.params.apply;
      let office = this.$route.params.office;
      if (office === 'doi') {
        this.$router.push({
          name: 'ExtendChangeVisa'
        })
        return
      }
      if (apply_type === 'arrival') {
        if (this.$store.state.Notification.fromPrm) {
          window.close()
        } else {
          window.location.href = '/on-arrival/' + office
        }
      } else {
        window.location.href = '/online'
      }
    },
    redirectHome() {
      this.dialog = true;
    },
    payThroughFCGO(pdfDetails) {
      let params = {}

        params = {
          code: pdfDetails.voucher_number,
          token: pdfDetails.voucher_token,
          sessionId: pdfDetails.malanika_session_id,
          api_url: pdfDetails.malanika_public_gateway
        }
      this.postToFCGO(params)
    },
    payThroughCard(pdfDetails) {
      const voucherNumber = pdfDetails.voucher_number;

      this.makeCardPayment(voucherNumber)
          .then(({ formData, url }) => {
            if (formData && url) {
              console.log('asas')
              this.postToConnectIPS(url, formData);
            } else {
              console.log('asasas')
              // console.error("Missing formData or url in response");
            }
          })
          .catch(err => {
            console.log('err')
            // console.error("Card payment failed:", err);
          });
    },

   async makeCardPayment(voucherNumber) {
      return Http.post(
          `${API_URL}${VERSION}/iPayment-public/${voucherNumber}`,
          {}, // empty body (like Content-Length: 0)
          {
            headers: {
              Accept: "application/json",
            }
          }
      ).then((response) => {

        this.$store.commit("setOffices", response.data);

        const formData = response.data.data.data.formData;
        const url = response.data.data.data.url;
        console.log('formData',formData)

        return { formData, url };
      });
    },

    postToConnectIPS(url, formData) {
      const newWindow = window.open("", "_blank", "width=1000,height=600,left=200,top=200");

      if (!newWindow) {
        alert("Please allow pop-ups to proceed with payment.");
        return;
      }

      const form = newWindow.document.createElement("form");
      form.method = "POST";
      form.action = url;

      Object.entries(formData).forEach(([key, value]) => {
        const input = newWindow.document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });

      newWindow.document.body.appendChild(form);
      form.submit();
    },
    // payThroughCard(pdfDetails) {
    //   const voucherNumber = pdfDetails.voucher_number;
    //
    //
    //   this.makeCardPayment(voucherNumber)
    //       .then(({ formData, url }) => {
    //         if (formData && url) {
    //           this.postToConnectIPS(url, formData);
    //         } else {
    //           console.error("Missing formData or url in response");
    //         }
    //       })
    //       .catch(err => {
    //         console.error("Card payment failed:", err);
    //       });
    // },
    // makeCardPayment(params) {
    //   return Http.post(API_URL + VERSION + '/iPayment-public', { params })
    //       .then((response) => {
    //         this.$store.commit('setOffices', response.data);
    //
    //         const formData = response.data.data.formData;
    //         const url = response.data.data.url;
    //
    //         return { formData, url };
    //       });
    // },
    //
    // postToConnectIPS(url, formData) {
    //   const newWindow = window.open("", "_blank", "width=1000,height=600,left=200,top=200");
    //
    //   if (!newWindow) {
    //     alert("Please allow pop-ups to proceed with payment.");
    //     return;
    //   }
    //
    //   const form = newWindow.document.createElement("form");
    //   form.method = "POST";
    //   form.action = url;
    //
    //   Object.entries(formData).forEach(([key, value]) => {
    //     const input = newWindow.document.createElement("input");
    //     input.type = "hidden";
    //     input.name = key;
    //     input.value = value;
    //     form.appendChild(input);
    //   });
    //
    //   newWindow.document.body.appendChild(form);
    //   form.submit();
    // },








    createFcgoForm(data){
      const form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute("action", data.api_url);

      const params = {
        code: data.code,
        token: data.token,
        sessionId: data.sessionId,
        lang: "np",
      };

      Object.entries(params).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.setAttribute("type", "text");
        input.setAttribute("name", key);
        input.setAttribute("value", value);
        form.appendChild(input);
      });

      return form;
    },

    postToFCGO(data) {
      const form = this.createFcgoForm(data);

      const newWindow = window.open(BASE_TOKEN, "_blank", "width=1000,height=600,left=200,top=200");

      if (newWindow) {
        try {
          newWindow.focus();
          newWindow.document.body.appendChild(form);
          form.submit();
        } finally {
          newWindow.document.body.removeChild(form);
        }
      } else {
        alert("Please allow pop-ups to open the form in a new window.");
      }
    },

  },
};
</script>

<style>
#printContent {
  display: none;
}

.show-content {
  padding: 0 300px !important;
}

@media only screen and (max-width: 600px) {
  .show-content {
    padding: 0 !important;
  }
}

@media print {
  .hide-on-print {
    display: none;
  }


  #printContent {
    display: block;
  }
}
</style>

